import React from 'react';
import { CodeBlock } from "react-code-blocks";
import { bodyCode, exampleErrorResponses, exampleSuccessResponse, headerCode } from './ApiQuoteCodeBlocks';
import ApiTableRow from '../api-table-row/ApiTableRow';
import { codeBlockTheme } from '../utilities';

const ApiQuotePage: React.FC<{
  data: any
  searchValue: string
  currentApiElement: any
}> = ({
  data,
  searchValue,
  currentApiElement
}) => {

  return (
    <div className="api-quote-page">
      <h2>Quote</h2>
      <p>To generate quote for a shipment.</p>
      <p>Quotes are stored for 5 days, you will need to save the quote ID from the quote returned on the payload response and pass into the create booking request. It will return a list of available services with relevant information and price breakdown.</p>

      <div className="api-url-box">
        <strong>POST</strong> /public/v1/quote
      </div>

{/* Header Parameters */}
      <div className="api-grid">
        <h2 id="quote-header-schema">Quote Request Header Parameters</h2>

        <div className="api-grid__table">
          <div className="api-grid__table__head">
            <h3>Parameter</h3>
            <h3>Constraint / Description</h3>
          </div>

          <div className="api-grid__table__body">

            {data && data.headers?.map((row: any, index: number) => {
              return (
                <ApiTableRow
                  key={index + row.title}
                  rowInfo={row}
                  searchValue={searchValue}
                  currentApiElement={currentApiElement}
                ></ApiTableRow>
              )
            })}
          </div>
        </div>

{/* Body */}
        <h2 id="quote-body-schema">Quote Request Body Schema</h2>

        <div className="api-grid__table">
          <div className="api-grid__table__head">
            <h3>Parameter</h3>
            <h3>Constraint / Description</h3>
          </div>

          <div className="api-grid__table__body">

            {data && data.body?.map((row: any, index: number) => {
              return (
                <ApiTableRow
                  key={index + row.title}
                  rowInfo={row}
                  searchValue={searchValue}
                  currentApiElement={currentApiElement}
                ></ApiTableRow>
              )
            })}
          </div>
        </div>
{/* ResponseSuccess */}
          <h2 id="quote-response-success-schema">Quote Response Success</h2>

          <div className="api-grid__table">
            <div className="api-grid__table__head">
              <h3>Parameter</h3>
              <h3>Constraint / Description</h3>
            </div>

            <div className="api-grid__table__body">

            {data && data.responseSuccess?.map((row: any, index: number) => {
              return (
                <ApiTableRow
                  key={index + row.title}
                  rowInfo={row}
                  searchValue={searchValue}
                  currentApiElement={currentApiElement}
                ></ApiTableRow>
              )
            })}
          </div>
        </div>

{/* ResponseError */}
          <h2 id="quote-response-error-schema">Quote Response Errors</h2>

          <div className="api-grid__table__head">
            <h3>Error Code</h3>
            <h3>Constraint / Description</h3>
          </div>
          {data && data.responseError?.map((row: any, index: number) => {
            return (
              <React.Fragment key={index + row.title}>
                <div className="api-grid__table api-grid__table--error-response">
                  <div className="api-grid__table__body">
                    <ApiTableRow
                      rowInfo={row}
                      searchValue={searchValue}
                      currentApiElement={currentApiElement}
                    ></ApiTableRow>
                  </div>
                </div>
                <div className="api-grid__example api-grid__example--error-response">
                  {/* @ts-ignore */}
                  <CodeBlock
                    //@ts-ignore
                    text={exampleErrorResponses[row.title]}
                    language='javascript'
                    showLineNumbers={true}
                    theme={codeBlockTheme}
                  />
                </div>
              </React.Fragment>
            )
          })}

        <div className="api-grid__example api-grid__example--header">
          <h3>Example Header</h3>
          {/* @ts-ignore */}
          <CodeBlock
            //@ts-ignore
            text={headerCode}
            language='javascript'
            showLineNumbers={true}
            theme={codeBlockTheme}
          />
        </div>

        <div className="api-grid__example api-grid__example--body">
          <h3>Example Body</h3>
          {/* @ts-ignore */}
          <CodeBlock
            //@ts-ignore
            text={bodyCode}
            language='javascript'
            showLineNumbers={true}
            theme={codeBlockTheme}
          />
        </div>

        <div className="api-grid__example api-grid__example--success-response">
          <h3>Example Success Response</h3>
          {/* @ts-ignore */}
          <CodeBlock
            //@ts-ignore
            text={exampleSuccessResponse}
            language='javascript'
            showLineNumbers={true}
            theme={codeBlockTheme}
          />
        </div>
      </div>

    </div>
  )
}

export default ApiQuotePage;